import { Component, AfterViewInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-hubspot-form',
  templateUrl: './hubspot-form.component.html',
  standalone: true,
  styleUrls: ['./hubspot-form.component.scss'],
  imports: [RouterOutlet]
})
export class HubspotFormComponent implements AfterViewInit {
  isLoading = true;

  constructor(public router: Router) {}

  ngAfterViewInit(): void {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/49530899.js';
    script.defer = true;
    document.body.appendChild(script);

    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }
}
